// src/theme/media.js
import { css } from 'styled-components';
import { BP } from './breakpoints';

export const media = {
  tiny:   (...a) => css`@media (max-width:${BP.tiny}px){${css(...a)}}`,
  tablet: (...a) => css`@media (max-width:${BP.tablet}px){${css(...a)}}`,
  desktop:(...a) => css`@media (max-width:${BP.desktop}px){${css(...a)}}`,
  header: (...a) => css`@media (max-width:${BP.headerCollapse}px){${css(...a)}}`,
};


